// extracted by mini-css-extract-plugin
module.exports = {"title":"Limits__title--1Y6","message":"Limits__message--2e3","form":"Limits__form--_Sy","control":"Limits__control--1Xc","submit":"Limits__submit--3Pq"};